import { Component } from '@angular/core';

@Component({
    selector: 'app-contact-us-sub-header',
    templateUrl: './contact-us-sub-header.component.html',
    styleUrls: ['./contact-us-sub-header.component.scss'],
    standalone: false,
})
export class ContactUsSubHeaderComponent {
    imgSrc: string = '../../../../../assets/media/logos/contact-icon-black.png';
    constructor() {}

    onMouseOver(): void {
        this.imgSrc = '../../../../../assets/media/logos/contact-icon-yellow.png';
    }

    onMouseOut(): void {
        this.imgSrc = '../../../../../assets/media/logos/contact-icon-black.png';
    }
}
